import { render, staticRenderFns } from "./EquipamentoPessoa.vue?vue&type=template&id=148a610a&scoped=true&"
import script from "./EquipamentoPessoa.vue?vue&type=script&lang=js&"
export * from "./EquipamentoPessoa.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoPessoa.vue?vue&type=style&index=0&id=148a610a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a610a",
  null
  
)

export default component.exports